import VueRouter, { RouteConfig } from 'vue-router'

const NoticeDetail = () => import('../views/official-notice/Detail.vue')
export const noticeDetailRoute: RouteConfig = {
  path: '/official-notice-detail',
  name: 'official_notice_detail',
  component: NoticeDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '官方通知',
  },
}
export function navigateToOfficialNoticeDetail(router: VueRouter, id: string) {
  router.push({ name: noticeDetailRoute.name, query: { id } })
}

export default [noticeDetailRoute]
